import React from 'react';
import HallOfFame from 'models/battles/HallOfFame';
import images from 'assets/images';
import { Tile } from '../Tile';
import { FormattedMessage } from 'react-intl';

export type StreakTileProps = {
	data: HallOfFame;
};

export const StreakTile = ({ data }: StreakTileProps) => {
	const currentData = data.players.highestWinStreak;

	if (!currentData) {
		return null;
	}

	return (
		<Tile
			title={<FormattedMessage id={`battle-hof.type.streak.title`} />}
			dateFrom={data.dateFrom}
			dateTo={data.dateTo}
			playerAvatar={currentData.avatar}
			playerName={currentData.fullname}
			icon={images.battles.battlesStreak}
			text={
				<FormattedMessage id={`battle-hof.type.streak.text`} values={{ value: currentData.currentWinStreak }} />
			}
		/>
	);
};
